import styled from "styled-components";
import bg from "../../../assets/loading.jpg";



export const StyledLoading = styled.div`
	width: 100%;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1010;
	gap: 40px;
	transition: 0.5s;
	background: var(--green50);

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	p {
		width: 220px;
		text-shadow: var(--textShadowBlack);
		font-size: 42px;
		color: var(--blue50);
		font-family: "Salsa", cursive;
	}
`;
